<template>
<div>
<div class="trainingReportBox noPrintModel">
    <div class="reportPage one_page">
        <div class="noPrintModel" style="height: 30px;"></div>
        <div class="firstTit">
            <h3>党建培训日志（修订）</h3>
        </div>
        <div class="twoTitinfo">
            <p>
                <span>时间：{{timeFrom.formattedDate}}</span>
                <span>{{timeFrom.dayOfWeek}}</span>
                <span>上课地点：{{tableFrom.address}}</span>
            </p>
            <p>
                <span>主教官：{{tableFrom.userName}} 班主任：{{tableFrom.masterName}}</span>
            </p>
        </div>
        <table>
            <tr>
                <td style="width: 80px;">课程</td>
                <td colspan="3">
                    <input class="noPrintModel editInputBg" v-model="tableFrom.name" type="text"/>
                </td>
                <td style="width: 80px;">主讲教官</td>
                <td style="min-width: 100px;" colspan="2">
                    <input class="noPrintModel editInputBg" disabled v-model="tableFrom.userName" type="text"/>
                </td>
                <td style="width: 90px;">辅助教官</td>
                <td style="text-align: left;">
                    <input class="noPrintModel editInputBg" v-model="tableFrom.userName2" type="text"/>
                </td>
            </tr>
            <tr>
                <td>应到人数</td>
                <td style="width: 100px;">
                    <input class="noPrintModel editInputBg" v-model="tableFrom.ydCount" type="text"/>
                </td>
                <td style="width: 90px;">实到人数</td>
                <td style="width: 100px;">
                    <input class="noPrintModel editInputBg" v-model="tableFrom.sdCount" type="text"/>
                </td>
                <td style="position: relative;" colspan="5">
                    <div class="supplementModel">
                        <div>请假人员姓名及原因</div>
                        <div>
                            <input class="noPrintModel editInputBg" v-model="tableFrom.leaveReason" type="text"/>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>教学准备</td>
                <td class="textCon" colspan="6">
                    <p>拟授科目的学员分析：</p>
                    <p>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxzbStudent" style="min-height:70px;margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                    <p>拟授科目教学目标：</p>
                    <p>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxzbTarget" style="min-height:70px;margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                </td>
                <td>训练器材及场地需求</td>
                <td style="text-align: left;">
                    <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxzbEquipment" style="min-height:190px;margin: 8px 0px;padding: 6px;"></textarea>
                </td>
            </tr>
            <tr>
                <td>教学实施</td>
                <td class="textCon" colspan="6">
                    <p>采取的教学方法：</p>
                    <p>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxssMethod" style="min-height:70px;margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                    <p>教学步骤：</p>
                    <p>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxssStep" style="min-height:70px;margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                </td>
                <td>训练中学员普遍反映的问题</td>
                <td style="text-align: left;">
                    <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxssQuestion" style="min-height:190px;margin: 8px 0px;padding: 6px;"></textarea>
                </td>
            </tr>
            <tr>
                <td>教学例会主要内容</td>
                <td class="textCon" colspan="6">
                    <p>训练中存在的问题：</p>
                    <p>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxlxQuestion" style="min-height:70px;margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                    <p>教学效果较差的内容：</p>
                    <p>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.jxlxContent" style="min-height:70px;margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                </td>
                <td class="textCon" colspan="2">
                    <p class="tsLine">
                        <span>优秀学员：</span>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.highStudent" style="margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                    <p class="tsLine">
                        <span>不合格学员：</span>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.lowStudent" style="margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                    <p class="tsLine">
                        <span>需补课学员及科目：</span>
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.otherCnt" style="margin: 8px 0px;padding: 6px;"></textarea>
                    </p>
                </td>
            </tr>
        </table>
        <div class="tableFootInfo">
            <p class="noPrintModel">
                <span>上下课时间：</span>
                <span>{{tableFrom.timeBegin}}</span>
                <span style="margin: 0px 5px;font-family:'微软雅黑';">~</span>
                <span>{{tableFrom.timeEnd}}</span>
                <!-- <el-time-picker
                v-model="tableFrom.timeBegin"
                value-format="HH:mm"
                ></el-time-picker>
                <span style="margin: 0px 5px;font-family:'微软雅黑';">~</span>
                <el-time-picker
                value-format="HH:mm"
                v-model="tableFrom.timeEnd"
                ></el-time-picker> -->
            </p>
            <p>新疆公安厅政治部教育训练处制表</p>
        </div>

        <div class="footPlayModel noPrintModel">
            <el-button @click.prevent="toSaveFile" type="success">打印</el-button>
            <el-button @click.prevent="updateFromFun" type="primary">提交</el-button>
            <el-button @click.prevent="$router.go(-1)" type="primary">返回</el-button>
        </div>
    </div>
</div>
<trainingDaYing v-if="showPrint" ref="printDom" :timeFrom="timeFrom" :infoFrom="tableFrom" class="printModel showPrintModel"></trainingDaYing>
</div>
</template>

<script>
import * as echarts from 'echarts';
import trainingDaYing from './trainingDaYing.vue';
import {
    getTeachrLogInfoApi,
    updateTeachrLogInfoApi
} from '@/api/personcenter/index';
export default {
    name: 'trainingReport',
    components:{
        trainingDaYing
    },
    data(){
        return {
            tableFrom:{},
            timeFrom:{},
            showPrint: false,
        }
    },
    mounted(){
        this.getInfo();
        if(this.$route.query.time){
            this.formatDate(this.$route.query.time);
        }
    },
    methods:{
        getInfo(){
            getTeachrLogInfoApi({id: this.$route.query.id}).then(res=>{
                if(res.code == 200){
                    this.tableFrom = res.result || {};
                    this.showPrint = true;
                }
            })
        },
        //去保存
        toSaveFile(){
            this.$refs.printDom.getFrom(this.tableFrom);
            this.$nextTick(()=>{
                window.print()
            })
        },
        //更新数据
        updateFromFun(){
            updateTeachrLogInfoApi(this.tableFrom).then(res=>{
                if(res.code == 200){
                    this.$message.success('提交成功');
                }
            })
        },
        formatDate(dateString){
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = date.getMonth() + 1; // getMonth() 返回的月份是从0开始的
            const day = date.getDate();
            // 将月份和日期格式化为两位数
            const formattedMonth = month < 10 ? `0${month}` : month;
            const formattedDay = day < 10 ? `0${day}` : day;
            // 格式化日期为 '2024年11月23日' 的形式
            const formattedDate = `${year}年${formattedMonth}月${formattedDay}日`;
            // 获取星期几
            const daysOfWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            const dayOfWeek = daysOfWeek[date.getDay()];
            this.timeFrom = {
                formattedDate,
                dayOfWeek
            };
        }
    }
}
</script>

<style lang="less" scoped>
h1,h2,h3{
    padding: 0px;
    margin: 0px;
}
.trainingReportBox{
    position: relative;
    margin: 0;
    padding: 20px 0px;
    background-color: #f2f2f2;

    .reportPage{
        width:calc(190.5mm*1.5);
        min-height: calc(247mm*1.5);
        margin: auto;
        margin-bottom: 20px;
        box-shadow: 1px 1px 8px #e2e2e2;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px 45px;
    }

    .one_page{
        font-family: '宋体';
        .firstTit{
            width: 100%;
            text-align: center;
            padding-bottom: 10px;
            h3{
                font-family: '宋体';
                font-size: 26px;
            }
        }
        .twoTitinfo{
            text-align: right;
            font-family: '宋体';
            font-size: 16px;

            p{
                padding-bottom: 6px;
                span + span{
                    margin-left: 10px;
                }
            }
        }
        table{
            width: 100%;
            border-collapse: collapse;
            font-family: '宋体';
            font-size: 16px;
            tr{
                text-align: center;
                th{
                    padding: 10px;
                }
                td{
                    box-sizing: border-box;
                    padding: 4px 4px;
                    border: 1px solid #000;
                }
                .textCon{
                    text-align: left;
                }
            }
        }
        .tableFootInfo{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 5px 0px;
        }

        .footPlayModel{
            padding-top: 20px;
            text-align: right;
        }
    }
}


.supplementModel{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    &>div{
        box-sizing: border-box;
        padding: 4px 4px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    &>div:nth-child(1){
        flex-shrink: 0;
        border-right: 1px solid #000;
        padding: 4px 8px;
    }
    &>div:nth-child(2){
        flex: 1;
    }
}

.showPrintModel{
    display: none;
}

.editInputBg{
    background-color: #f2f2f2;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    padding: 0px 6px;
    font-size: 16px;
    border-radius: 2px;
    border: 1px solid transparent;
    &:focus{
        border-color: #409EFF;
    }
}

.tsLine{
    display: flex;
    align-items: center;
    &>span:nth-child(1){
        flex-shrink: 0;
        display: inline-block;
    }
}

.printModel{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    min-height: 100vh;
}

@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    *,body,#app{
        padding: 0px;
        margin: 0px;
    }

    .one_page>table tr td{
        padding: 10px 4px;
    }

    .trainingReportBox{
        background-color: #fff;
        padding: 0px;
    }
    .reportPage{
        width: 190.5mm;
        min-height: 247mm;
        box-shadow: none !important;
        margin-bottom: 0px !important;
        padding: 0px !important;
    }
    .noPrintModel{
        display: none;
    }
    .showPrintModel{
        display: block;
    }
}

</style>